var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 54,
    viewBox: "0 0 67 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3034 53V28.4003L66.5914 16.1097V39.7676C66.5914 40.3651 66.2931 40.8817 65.7757 41.1804L45.3034 53ZM19.6954 40.7737H2.51929C1.12802 40.7737 0 39.6457 0 38.2544C0 36.8632 1.12802 35.7351 2.51929 35.7351H19.6058C22.5603 35.7351 22.5603 31.0168 19.6058 31.0168H9.33801C7.94675 31.0168 6.8186 29.8887 6.8186 28.4975C6.8186 27.1062 7.94675 25.9782 9.33801 25.9782H17.3688C20.3233 25.9782 20.3233 21.2598 17.3688 21.2598H2.51942C1.12815 21.2598 0.000130061 20.1318 0.000130061 18.7405C0.000130061 17.3493 1.12815 16.2213 2.51942 16.2213H19.777L40.8723 28.4007V53L19.6954 40.7737ZM21.7838 12.2762L43.0878 24.576L64.3917 12.2761L43.1286 0H29.1777C27.7864 0 26.6584 1.12802 26.6584 2.51929C26.6584 3.91055 27.7864 5.03858 29.1777 5.03858H32.1259C32.3967 5.03858 32.6237 5.21273 32.6938 5.47428C32.7638 5.73583 32.6544 6.00012 32.4199 6.13564L21.7838 12.2762ZM20.5712 0C21.9624 0 23.0904 1.12802 23.0904 2.51929C23.0904 3.91055 21.9624 5.03858 20.5712 5.03858H5.25812C3.86685 5.03858 2.7387 3.91055 2.7387 2.51929C2.7387 1.12802 3.86672 0 5.25812 0H20.5712Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 15.5L45 28.5V53.5C51.6667 49.6667 65.2 41.9 66 41.5C66.8 41.1 67 40.3333 67 40V15.5Z",
    fill: "#FF3811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryt);
export default __webpack_public_path__ + "static/media/deliveryt.0516b210d38b021519ec285af48a0c4e.svg";
export { ForwardRef as ReactComponent };